import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'md-table',
  templateUrl: './table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent {
  // @ts-expect-error
  @Input() tableClasses:
    | string
    | string[]
    | Set<string>
    | {
        [klass: string]: any;
      };

  /**
   * @example <md-table colWidths="['10%', '90%']"></md-table>
   */
  @Input() colWidths?: string[];
}
